import { render, staticRenderFns } from "./minusSettlementDialog.vue?vue&type=template&id=81d63ca8"
import script from "./minusSettlementDialog.vue?vue&type=script&lang=js"
export * from "./minusSettlementDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports